import { render } from "./RefundAlert.vue?vue&type=template&id=2c8e4548&scoped=true"
import script from "./RefundAlert.vue?vue&type=script&lang=js"
export * from "./RefundAlert.vue?vue&type=script&lang=js"

import "./RefundAlert.vue?vue&type=style&index=0&id=2c8e4548&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8e4548"]])

export default __exports__